// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"23d5f36f","280":"0e6615c3","288":"44428220","453":"54292a4b","599":"4dcf8c35","623":"7c97b486","863":"9c40820c","951":"8776f423","967":"57585762","992":"5ca32d56"}[chunkId] + ".chunk.js";
};